import { JsonObject, JsonProperty } from 'json2typescript';

import { Id } from './id';
import { IdAdapter } from '../../client/helpers/serializer/adapters/id.adapter';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';
import { TypeDistribution } from './type-distribution';
import { ValidModelInterface } from '../../../core';

@JsonObject('ValidModel')
export class ValidModel implements ValidModelInterface {
    @JsonProperty('Id', IdAdapter, true)
    private _id: Id = undefined;

    @JsonProperty('AdvisoryModel', StringAdapter, true)
    private _advisoryModel: string = undefined;

    @JsonProperty('AdvisoryModelId', IdAdapter, true)
    private _advisoryModelId: Id = undefined;

    @JsonProperty('MainDistribution', [TypeDistribution], true)
    private _distributions: TypeDistribution[] = [];

    @JsonProperty('Code', StringAdapter, true)
    private _code: string = undefined;

    @JsonProperty('ModelPortfolioCode', IdAdapter, true)
    private _modelCode: Id = undefined;

    @JsonProperty('Name', StringAdapter, true)
    private _name: string = undefined;

    @JsonProperty('RiskProfileName', StringAdapter, true)
    private _riskProfileName: string = undefined;

    get id(): Id {
        return this._id;
    }

    get advisoryModel(): string {
        return this._advisoryModel;
    }

    set advisoryModel(newModel: string) {
        this._advisoryModel = newModel;
    }

    get advisoryModelId(): Id {
        return this._advisoryModelId;
    }

    set advisoryModelId(value: Id) {
        this._advisoryModelId = value;
    }

    get distributions(): TypeDistribution[] {
        if (!this._distributions) {
            this._distributions = [];
        }

        return this._distributions;
    }

    get code(): string {
        return this._code;
    }

    set code(value: string) {
        this._code = value;
    }

    get modelCode(): Id {
        return this._modelCode;
    }

    set modelCode(value: Id) {
        this._modelCode = value;
    }

    get name(): string {
        return this._name;
    }

    set name(value: string) {
        this._name = value;
    }

    get riskProfileName(): string {
        return this._riskProfileName;
    }

    set riskProfileName(value: string) {
        this._riskProfileName = value;
    }
}
